<template>
  <div>
    <Checkbox
      :class="checkboxClassName"
      id="usa"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p><b>Страхователь подтверждает, что не имеет гражданства США, разрешения на постоянное пребывание в США и не является налоговым резидентом США.</b></p>
    </Checkbox>
    <Checkbox
      :class="checkboxClassName"
      id="person"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p><b>Страхователь подтверждает, что не является:</b></p>
    </Checkbox>
    <p>- иностранным публичным должностным лицом, должностным лицом публичных международных организаций;</p>
    <p>- лицом, замещающим (занимающим) государственные должности РФ, должности членов Совета директоров ЦБ РФ, должности федеральной государственной службы, назначение на которые и освобождение от которых осуществляется Президентом РФ или Правительством РФ, должности в ЦБ РФ, государственных корпорациях и иных организациях, созданных РФ на основании федеральных законов, включенные в перечни должностей, определяемые Президентом РФ;</p>
    <p>- супругой(-ом), близким родственником лиц, указанных в настоящем подпункте.</p>
    <p>Оплачивать договор страхования необходимо банковской картой, оформленной на имя Страхователя. При оплате договора третьим лицом может быть удержан налог с внесенной суммы.</p>
    <Checkbox
      :class="checkboxClassName"
      id="nalog"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p><b>Страхователь подтверждает, что ему доведена следующая информация:</b></p>
    </Checkbox>
    <p>- в соответствии со ст. 213 НК РФ страховая выплата по окончанию договора страхования не облагается налогом на доходы физических лиц в полном объеме в случаях, если оплата договора страхования производилась лично Страхователем за счет его собственных средств. В иных случаях может быть удержан налог с суммы оплаченных взносов.</p>
    <Checkbox
      :class="checkboxClassName"
      id="politics"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p>Согласен с
        <a :href="links.politics"
           target="_blank"
        >Политикой обработки данных</a>.
      </p>
    </Checkbox>
    <Checkbox
      v-if="confirmationChecks.hasOwnProperty('agreement')"
      :class="checkboxClassName"
      id="agreement"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p>Ознакомился и согласился с
        <a :href="links.agreement"
           target="_blank"
        >Пользовательским соглашением</a>.
      </p>
    </Checkbox>
    <Checkbox
      v-if="confirmationChecks.hasOwnProperty('kid')"
      :class="checkboxClassName"
      id="kid"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p>Ознакомился с <a :href="links.kid" :class="{'pointer': !links.kid}" :target="otp ? undefined : '_blank'">Ключевым информационным документом</a>.</p>
    </Checkbox>
    <Checkbox
      :class="checkboxClassName"
      id="policy"
      :checker="confirmationChecks"
      :icon="icon"
    >
      <p>Ознакомился и согласился с <a :href="links.policy" :class="{'pointer': !links.policy}" :target="otp ? undefined : '_blank'">Условиями полиса</a> и <a :href="links.rules" :target="otp ? undefined : '_blank'">Правилами страхования</a>.</p>
    </Checkbox>
    <p><b :class="checkboxClassName"><slot></slot></b></p>
  </div>
</template>

<script>
import Checkbox from '@/create/components/landingsConstructor/Checkbox.vue';

  export default {
    components: {
      Checkbox,
    },
    props: {
      confirmationChecks: Object,
      checkboxClassName: String,
      icon: String,
      links: Object,
      otp: Boolean
    }
  }
</script>

<style lang="scss" scoped >
.pointer {
  pointer-events: none;
}
</style>